const SCRIPT_FILE_EXTENSION = /\.(m?js|jsx?|tsx?)$/;

/**
 * Scripts injected by the browser (eg: Chrome iOS's built-in Google Translate)
 * report the page URL as their filename (eg: `https://www.nerdydata.com/mcp`)
 * instead of a `.js` bundle, so errors thrown inside them aren't ours to fix.
 */
export default function isInjectedScriptError(event: ErrorEvent): boolean {
  if (!event.filename) {
    return false;
  }
  try {
    const { pathname } = new URL(event.filename, window.location.href);
    return !SCRIPT_FILE_EXTENSION.test(pathname);
  } catch {
    return false;
  }
}
